import self from "../img/self.png";
import mock1 from "../img/mock1.png";
import mock2 from "../img/mock2.png";
import mock3 from "../img/mock3.png";
import mock4 from "../img/mock4.png";
import mock5 from "../img/mock5.png";

import aifluencer from "../img/aifluencer.png";
import tudub from "../img/tudub.png";
import viadm from "../img/viadm.png";
import dharmaya from "../img/dharmaya.png";

import newAifluencer from "../img/newAifluencer.png";
import newTudub from "../img/newTudub.png";
import newViadm from "../img/newViadm.png";
import newDharmaya from "../img/newDharmaya.png";

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
  firstName: "Bibhuti",
  lastName: "Swain",
  initials: "js", // the example uses first and last, but feel free to use three or more if you like.
  position: "A Full Stack Developer",
  selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],
  miniBio: [
    // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
    {
      emoji: "📱",
      text: "Experienced mobile developer",
    },
    {
      emoji: "🌱",
      text: "I’m currently learning Native Languages",
    },
    {
      emoji: "👯",
      text: "I’m looking to collaborate with geeks",
    },
    {
      emoji: "🥅",
      text: "Contribute more to Open Source projects",
    },
  ],
  socials: [
    {
      link: "https://www.instagram.com/bibhuti__swain",
      icon: "fa fa-instagram",
      label: "instagram",
    },
    {
      link: "https://github.com/bibhuti9",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://www.linkedin.com/in/bibhuti-swain/",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "https://medium.com/@bibhuti9",
      icon: "fa fa-medium",
      label: "medium",
    },
    // Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
    // Just change the links so that they lead to your social profiles.
  ],
  bio: "Hello! I'm John. I'm a systems engineer for Google. I studied CompSci at Harvard, I enjoy long walks on the beach, and I believe artificial intelligence will inevitably rule us all one day. You should hire me!",
  skills: {
    proficientWith: [
      "javascript",
      "react",
      "git",
      "github",
      "bootstrap",
      "html5",
      "css3",
      "figma",
    ],
    exposedTo: ["nodejs", "python", "adobe illustrator"],
  },
  hobbies: [
    {
      label: "reading",
      emoji: "📖",
    },
    {
      label: "theater",
      emoji: "🎭",
    },
    {
      label: "movies",
      emoji: "🎥",
    },
    {
      label: "cooking",
      emoji: "🌶",
    },
    // Same as above, change the emojis to match / relate to your hobbies or interests.
    // You can also remove the emojis if you'd like, I just think they look cute :P
  ],
  portfolio: [
    // This is where your portfolio projects will be detailed
    {
      title: "Aifluencer",
      live: "https://ainfluencer.com/", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
      image: newAifluencer,
      about:
        "Ainfluencer is the easiest, fastest, and most cost effective way to run Instagram and TikTok influencer marketing campaigns.",
    },
    {
      title: "TuduB",
      image: newTudub,
      about:
        "TuduB is your go-to task management and map-based reminder app, offering seamless scheduling and intuitive categorization for all your tasks",
    },
    {
      title: "Dharmaya",
      image: newDharmaya,
      about:
        "Experience the ultimate spiritual journey with our innovative app that seamlessly combines temple bookings, enriching book reading, and immersive audio and video content.",
    },
    {
      title: "Via DM",
      image: newViadm,
      about:
        "Discover meaningful connections effortlessly with Via DM, a social media collaboration platform that enables direct messaging. Uncover organic interactions and connect.",
    },
  ],
};
